import React from 'react';
import { useHistory } from 'react-router-dom';
import car from 'src/assets/images/icons/car-white.svg';
import area from 'src/assets/images/icons/expand-square.svg';
import bed from 'src/assets/images/icons/bed-white.svg';
import pinDrop from 'src/assets/images/icons/pin-drop.svg';
import arrowBack from 'src/assets/images/icons/arrow-back.svg';
import arrowForward from 'src/assets/images/icons/arrow-forward.svg';

export const CardMainPropertyInfo = ({ realEstate }) => {
  const history = useHistory();

  const handleInfoClick = (event) => {
    if (event.target.classList.contains('swiper-custom-button-prev') || 
        event.target.classList.contains('swiper-custom-button-next') ||
        event.target.parentElement.classList.contains('swiper-custom-button-prev') || 
        event.target.parentElement.classList.contains('swiper-custom-button-next')) {
      return;
    }

    history.push(`/${realEstate.slug}`);
  };

  return (
    <div className="container" role="button" tabIndex={0} onClick={handleInfoClick} style={{ cursor: 'pointer' }}>
      <div className="info top-info">
        <h1 className="block-title-category">{realEstate.category && realEstate.category.name}</h1>
        <h2 className="block-title-location">
          <img alt="" src={pinDrop} className="icon" />
          {`${realEstate.neighbourhood} - ${realEstate.city}`}
        </h2>
      </div>
      <div className="info bottom-info">
        <div className="feature">
          {realEstate.bedrooms !== '0' && (
          <>
            <img alt="" src={bed} className="icon" />
            <span className="info-feature">
              {realEstate.bedrooms}
              {' '}
              quartos
            </span>
          </>
          )}
        </div>
        <div className="feature">
          <img alt="" src={area} className="icon" />
          <span className="info-feature">
            {Number.parseFloat(realEstate.area).toFixed(0)}
            m²
          </span>
        </div>
        <div className="feature">
          {realEstate.parkingSpaces !== '0' && (
            <>
              <img alt="" src={car} className="icon" />
              <span className="info-feature">
                {realEstate.parkingSpaces}
                {' '}
                vagas
              </span>
            </>
          )}
        </div>
      </div>

      <div className="swiper-custom-navigation swiper-custom-navigation-desktop">
        <div className="swiper-custom-button-prev">
          <img alt="" src={arrowBack} className="icon" />
        </div>
        <div className="swiper-custom-button-next">
          <img alt="" src={arrowForward} className="icon" />
        </div>
      </div>
    </div>
  );
};

export default function CardMainProperty({ realEstate }) {
  const history = useHistory();

  if (!realEstate) {
    return null;
  }

  const images = realEstate.gallery;

  let mainImage = '';
  if (images.length) {
    mainImage = images[0].image;
  }

  const handleBannerClick = (event) => {
    event.preventDefault();

    if (event.nativeEvent.target.classList.contains('swiper-custom-button-prev') || event.nativeEvent.target.classList.contains('swiper-custom-button-next')) {
      return;
    }

    if (event.nativeEvent.target.parentElement.classList.contains('swiper-custom-button-prev') || event.nativeEvent.target.parentElement.classList.contains('swiper-custom-button-next')) {
      return;
    }

    history.push(`/${realEstate.slug}`);
  };

  return (
    <div role="button" tabIndex={0} className="card card-main-property" onClick={handleBannerClick} style={{ cursor: 'pointer' }}>
      <div className="property-content-overlay" />
      <div className="property-content" style={{ backgroundImage: `url(${mainImage})` }}>
        <div className="swiper-custom-navigation swiper-custom-navigation-mobile">
          <div className="swiper-custom-button-prev">
            <img alt="" src={arrowBack} className="icon" />
          </div>
          <div className="swiper-custom-button-next">
            <img alt="" src={arrowForward} className="icon" />
          </div>
        </div>
      </div>
    </div>
  );
}
